<script>
import {
  ArrowUpIcon,
  PlayIcon,
  MonitorIcon,
  HeartIcon,
  EyeIcon,
  BoldIcon,
  FeatherIcon,
  CodeIcon,
  UserCheckIcon,
  GitMergeIcon,
  SettingsIcon,
  VideoIcon,
} from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import News from "@/components/news";
import Features from "@/components/features";
import Testimonial from "@/components/testimonial";
import axios from "axios";
import config from "@/config.json";
import {post} from "@/assets/js/utils";

/**
 * Index agency component
 */
export default {
  data() {
    const ua = navigator.userAgent.toLowerCase();
    const os = ua.indexOf("mac") > 0? 'mac' : 'win';
    return {
      lang: this.getLang(),
      downloadUrl: "#",
      os : os,
      selected: os,
      release: {
        app: "",
        vcname: "",
        vc: 0,
        mac_url: "",
        win_url: "",
        created_at: "",
      }
    };
  },
  mounted() {
    this.getRelease();
  },
  methods: {
    async getRelease() {
      try {
        const data = await post(`${config.api.latestrelease}`, {app: "Ps.Mirror"});
        if (data.errno === 0) {
          this.release = data.data;
          this.downloadUrl = (this.selected === "mac")? this.release.mac_url : this.release.win_url;
        } else {
        }
      } catch (e) {}
    },
    toggleOS() {
      this.selected = (this.selected === "mac")? "win" : "mac";
      this.downloadUrl = (this.selected === "mac")? this.release.mac_url : this.release.win_url;
    }
  },
  components: {
    Navbar,
    Footer,
    News,
    Features,
    ArrowUpIcon,
    Carousel,
    Slide,
    PlayIcon,
    MonitorIcon,
    HeartIcon,
    EyeIcon,
    BoldIcon,
    FeatherIcon,
    CodeIcon,
    UserCheckIcon,
    GitMergeIcon,
    SettingsIcon,
    VideoIcon,
    Testimonial,
  },
};
</script>

<template>
  <div>
    <Navbar />
    <!-- Hero Start -->
    <section class="bg-half-170 border-bottom agency-wrapper d-table w-100" id="home" >
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-7 order-1 order-md-2">
            <div class="title-heading mt-4 ml-lg-5">
              <h1 class="heading mb-3">{{$t('photoshop.title')}} </h1>
              <p class="para-desc text-muted">{{$t('photoshop.description')}}<span class="text-danger font-weight-bold">{{$t('photoshop.version_support')}}</span> </p>
              <div class="mt-4 pt-2">
                <a href="#" @click.prevent="toggleOS" class="btn btn-icon btn-pills" :class="{'btn-info': selected === 'win', ' btn-primary': selected === 'mac'}">
                  <i class="mdi " :class="{'mdi-microsoft-windows': selected === 'win', 'mdi-apple': selected === 'mac'}"></i>
                </a>
                <a :href="downloadUrl" onclick="_czc.push(['_trackEvent', 'app', 'download', 'photoshop']);" class="btn ml-2"  :class="{'btn-info': selected === 'win', ' btn-primary': selected === 'mac'}">{{$t('photoshop.download')}} <i class="mdi mdi-download"></i ></a>

              </div>
              <div>
                <span class="badge badge-pill badge-outline-light">{{$t('photoshop.version')}} {{release.vcname}}，{{$t('photoshop.update_time')}} {{release.created_at | formatDate}} </span>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-5 order-2 order-md-1 mt-4 pt-2 mt-sm-0 pt-sm-0" >
            <img width="2048" height="1277" loading="eager" fetchpriority="high" src="/images/photoshop/photoshop.png" :alt="$t('alt.ps_panel')" style="width: 1024px; margin-left: -600px" />
          </div>
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Key Feature Start -->
      <div class="container mt-5 mb-5">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h2 class="h4 title mb-4">{{$t('photoshop.install.title')}}</h2>
              <p class="text-muted para-desc mx-auto mb-0">{{$t('photoshop.install.description')}} </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
          <div class="col-lg-6 col-md-6">
            <img width="1470" height="1112" loading="lazy" src="/images/photoshop/Snip20211218_7.png" class="img-fluid" :alt="$t('alt.ps_install')" />
            <!--
            <img width="946" height="738" loading="lazy" src="/images/photoshop/Snip20211218_5.png" class="img-fluid" :alt="$t('alt.ps_install')" />
            -->
          </div>
          <!--end col-->

          <div class="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div class="section-title ml-lg-3">
              <h2 class="h4 title mb-4">
                {{$t('photoshop.install.step1.title')}}
              </h2>
              <p class="text-muted dm-multiline"> {{$t('photoshop.install.step1.detail')}} </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->


        <div class="row mt-5">
          <div class="col-lg-6 col-md-6">
            <img width="1024" height="408" loading="lazy" src="/images/photoshop/Snip20211218_8.png" class="img-fluid" :alt="$t('alt.ps_install')" />
          </div>
          <!--end col-->

          <div class="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div class="section-title ml-lg-3">
              <h2 class="h4 title mb-4">
                {{$t('photoshop.install.step2.title')}}
              </h2>
              <p class="text-muted dm-multiline"> {{$t('photoshop.install.step2.detail')}} </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->


        <div class="row mt-5">
          <div class="col-12">
            <div class="section-title text-center">
              <h2 class="h4 title mb-3">
                {{$t('photoshop.install.step3.title')}}
              </h2>
              <p class="text-muted mb-0 dm-multiline"> {{$t('photoshop.install.step3.detail')}} </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

      </div>
      <!--end container-->
    <!-- Key Feature End -->


    <!-- Section End -->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style>

</style>

<style scoped>
/* 安装说明用 \n 分段；HTML 默认会把换行折叠成空格。 */
.dm-multiline {
  white-space: pre-line;
}
</style>
